export default class DataManagementJob {
    constructor (dto) {
        this.id = 0;
        this.description = '';
        this.conditionStr = '';
        this.displayConditionStr = '';
        this.type = null;

        if (dto) {
            this.id = dto.id;
            this.description = dto.description;
            this.conditionStr = dto.searchPattern;
            this.displayConditionStr = dto.searchPattern;
            this.type = dto.type;
        }
    }

    toDto () {
        return {
            Id: this.id,
            Description: this.description,
            SearchPattern: this.conditionStr,
            Type: this.type,
        };
    }
}
